import { createFileRoute } from "@tanstack/react-router";
import RemindersPage from "@/site/pages/reminders";
// Search-param constants come from the dependency-free shared module, NOT the
// page: a runtime import from the page module defeats the router's component
// code-splitting and drags the whole reminders tree (dialogs, contact form,
// the 80KB countries JSON) into the entry chunk.
import {
  REMINDER_TYPE_CODES,
  type ReminderTypeCode,
  type RemindersSort,
} from "@shared/reminders-data";

// Old app's reminders list lived at /reminders — keep the URL.
interface RemindersSearch {
  /** Omitted = next-date sort, matching the old app's default. */
  sort?: RemindersSort;
  /** Omitted = all reminder types (old calendar_type_id filter). */
  type?: ReminderTypeCode;
  /** Text search over names/emails/labels (old search_tx). */
  q?: string;
  /** Share dialog open (deep-linkable so the nav menu can open it on mobile). */
  share?: boolean;
  /** Birthday Requests hub open (general link + pending list). */
  requests?: boolean;
  /** Add-birthday dialog open (the /reminders/birthday/add legacy URL lands here). */
  add?: boolean;
}

function isReminderType(value: unknown): value is ReminderTypeCode {
  return typeof value === "string" && (REMINDER_TYPE_CODES as readonly string[]).includes(value);
}

export const Route = createFileRoute("/reminders")({
  validateSearch: (search: Record<string, unknown>): RemindersSearch => {
    const out: RemindersSearch = {};
    if (search.sort === "first" || search.sort === "last") out.sort = search.sort;
    if (isReminderType(search.type)) out.type = search.type;
    if (typeof search.q === "string" && search.q) out.q = search.q;
    if (search.share === true) out.share = true;
    if (search.requests === true) out.requests = true;
    if (search.add === true) out.add = true;
    return out;
  },
  component: RemindersPage,
});
